<template>
  <dashboard-page title="Editar tipo de requerimento">
    <b-container fluid>
      <b-row>
        <b-col>
          <div class="card-wrapper">
            <issues-types-form-edit
              :issuesTypes="issuesTypesParameter"
              v-if="issuesTypesParameter.title"
            ></issues-types-form-edit>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </dashboard-page>
</template>

<script>
import IssuesTypesFormEdit from "./IssuesTypesFormEdit/IssuesTypesFormEdit.vue";
export default {
  name: "issues-form",
  components: {
    IssuesTypesFormEdit
  },
  data() {
    return {
      issuesTypesParameter: {
        title: null,
        description: null,
        id: null
      }
    };
  },
  created() {},
  mounted() {
    if (this.$route.params.issuesTypes) {
      console.log("parametros issuestypes", this.$route.params.issuesTypes);
      this.issuesTypesParameter.title = this.$route.params.issuesTypes.label;
      this.issuesTypesParameter.description = this.$route.params.issuesTypes.description;
      this.issuesTypesParameter.id = this.$route.params.issuesTypes.id;
    } else {
      this.$router.push("/issuesTypes");
      return;
    }
  }
};
</script>
